import { useOidc } from '@axa-fr/react-oidc';
import { clearAllUserSession, IconButton, useMessageChannelContext } from '@healthhub/react-ui';
import { Modal, Typography } from 'antd';
import { memo, useEffect, useState } from 'react';

import { FilledCloseIcon } from '@shared/assets-icon';
import { Button } from '@shared/components';
import { sitecoreHomeBaseUrl } from '@shared/configs/configs/config';
import { useLayoutViewContext } from '@shared/context';
import useIsAuthenticated from '@shared/hooks/useIsAuthenticated';
import { useGetProfileEligibilityAliveQuery } from '@shared/services/profileEligibility';
import { persistor } from '@shared/stores';
import { MESSAGE_ACTION } from '@shared/utils/bridge';
import { clearCookies } from '@shared/utils/cookie';

const { Text } = Typography;

const DeceasedProfileModal = () => {
  const { isPortalView } = useLayoutViewContext();

  const { logout } = useOidc();
  const { isAuthenticated } = useIsAuthenticated();
  const { isLoading, data } = useGetProfileEligibilityAliveQuery(undefined, { skip: !isAuthenticated });
  const [isOpen, setIsOpen] = useState(false);
  const { sendMessageToNative } = useMessageChannelContext();

  const onClickCloseButton = async () => {
    setIsOpen(false);
    clearAllUserSession({ persistor, clearCookies });
    await logout(sitecoreHomeBaseUrl());

    if (!isPortalView) {
      sendMessageToNative(MESSAGE_ACTION.unauthorised());
    }
  };

  useEffect(() => {
    if (data?.IsAlive === false && !isLoading) {
      setIsOpen(true);
    }
  }, [data?.IsAlive, isLoading, isAuthenticated]);

  if (!isAuthenticated) return null;

  return (
    <Modal
      centered
      className="lg:max-w-130 max-w-[21.438rem] [&_.ant-modal-body]:rounded-2xl [&_.ant-modal-body]:bg-secondary-yellow"
      closeIcon={
        <IconButton
          aria-label="Close"
          icon={<FilledCloseIcon className="absolute right-4 top-4 size-5" />}
          onClick={onClickCloseButton}
        />
      }
      destroyOnHidden
      footer={null}
      open={isOpen}
      width="100%"
    >
      <section className="flex flex-col gap-y-8">
        <section className="flex flex-col gap-y-4 text-center">
          <Text className="text-2xl font-semibold">
            We are unable to display the health records you have requested.
          </Text>
          <Text className="text-base">(Error code: S0001)</Text>
          <Text className="text-base">Contact us if you require any further assistance.</Text>
        </section>
        <Button
          className="w-32 self-center bg-primary-blue-grey-3 [&_span]:text-white"
          onClick={onClickCloseButton}
          variant="primary"
        >
          Close
        </Button>
      </section>
    </Modal>
  );
};

export default memo(DeceasedProfileModal);
